import {
	Component,
	Input,
	OnDestroy,
	ViewChild,
	ElementRef,
	EventEmitter,
	Output,
	ViewEncapsulation,
	SimpleChanges,
	forwardRef
} from '@angular/core';
import { IdService, FormControlBase } from '../../shared/index';
import { ISwitchState } from './switch.types';
import { NG_VALUE_ACCESSOR } from '@angular/forms';
import { fromEvent, Observable } from 'rxjs';
import { take } from 'rxjs/operators';

@Component({
	selector: 'rbc-switch',
	templateUrl: './switch.component.html',
	styleUrls: ['./switch.component.scss'],
	encapsulation: ViewEncapsulation.None,
	providers: [
		{
			provide: NG_VALUE_ACCESSOR,
			multi: true,
			useExisting: forwardRef(() => SwitchComponent)
		}
	]
})
export class SwitchComponent extends FormControlBase<boolean> implements OnDestroy {
	@Input() id: string;
	@Input() disabled: string | boolean = false;
	@Input() disableEventBus: boolean = false;
	@Input() label: string;
	@Input() name: string;
	@Input() size: 'small' | 'medium' = 'medium';
	@Input() model: boolean;
	@Input() ariaDescribedby: string;

	@Output() checkboxupdate = new EventEmitter<ISwitchState>();

	@ViewChild('control') control: ElementRef;
	@ViewChild('formSwitchWrapper') formSwitchWrapper: ElementRef;

	mouseoutObservable: Observable<any>;

	constructor(private idService: IdService) {
		super();
		this.id = this.idService.generate();
	}

	ngOnDestroy(): void {
		this.idService.remove(this.id);
		super.ngOnDestroy();
	}

	ngOnChanges(changes: SimpleChanges) {
		super.ngOnChanges(changes);

		if (changes && changes.model) {
			super.writeValue(changes.model.currentValue);
		}
	}

	onChange(newState) {
		const checked = !!newState;
		this.setModel(checked);
		this.checkboxupdate.emit({ id: this.id, checked });

		if (!this.mouseoutObservable) {
			this.mouseoutObservable = fromEvent(this.formSwitchWrapper.nativeElement, 'mouseout');

			this.mouseoutObservable.pipe(take(1)).subscribe(this.removeFocus.bind(this));
		}
	}

	removeFocus() {
		if (this.control) {
			this.control.nativeElement.blur();
			this.mouseoutObservable = null;
		}
	}
}
